export default __webpack_public_path__ + "static/media/detail_big_11_4.106cb1d8.jpg";